import React from 'react';
import { LOGO_VIEWBOX, getLogoContent } from '../assets/logoDefinition';

interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
}

/**
 * Better TDL Logo Component
 *
 * Displays the checkmark-tree logo used throughout the application.
 * The logo definition comes from src/assets/logoDefinition.js - the single source of truth.
 *
 * The logo combines:
 * - A checkmark spine (task completion progress)
 * - Branching tree structure (hierarchical complexity)
 * - Gradients and glows (energy of completing complex tasks)
 * - Sparks/particles (representing the complexity and satisfaction of completion)
 */
export const Logo: React.FC<LogoProps> = ({
  width = 120,
  height = 120,
  className
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={LOGO_VIEWBOX}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      dangerouslySetInnerHTML={{ __html: getLogoContent() }}
    />
  );
};

export default Logo;
